<template>
    <div class="container">
        <div class="row">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">Login</div>

                    <div class="card-body">
                        <p v-if="loginMessage">
                            {{loginMessage}}
                        </p>
                        <form @submit.stop.prevent="onSubmit">
                            <messages :messages="messages"/>
                            <div class="container">
                                <div class="row" v-if="confirm">
                                    <div class="col-md-8 offset-md-4 button-container">
                                        <button type="submit" class="btn btn-primary" :disabled="loading">
                                            Continue
                                        </button>
                                    </div>
                                </div>
                                <template v-else>
                                    <div class="row">
                                        <b-form-group v-if="!this.user_id"
                                                      class="col-md-8"
                                                      label="Username"
                                                      :label-for="getId('username')"
                                                      :state="fieldState('username')"
                                                      :invalid-feedback="invalidField('username')"
                                        >
                                            <b-form-input
                                                :id="getId('username')"
                                                type="text"
                                                v-model="username"
                                                :state="fieldState('username')"
                                                placeholder="Enter username">
                                            </b-form-input>
                                        </b-form-group>

                                        <b-form-group v-if="!forgot" class="col-md-8"
                                                      label="Password"
                                                      :label-for="getId('password')"
                                                      :state="fieldState('password')"
                                                      :invalid-feedback="invalidField('password')"
                                        >
                                            <b-form-input
                                                :id="getId('password')"
                                                type="password"
                                                v-model="password"
                                                :state="fieldState('password')"
                                                placeholder="Enter password">
                                            </b-form-input>

                                        </b-form-group>
                                    </div>
                                    <div class="form-group row mb-0">
                                        <div class="col-md-8 button-container">
                                            <button type="submit" class="btn btn-primary mr-2" :disabled="loading">
                                                <template v-if="forgot">Reset Password</template>
                                                <template v-else>Login</template>
                                            </button>
                                            <router-link to="/auth/forgot-password">Forgot password</router-link>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {getExceptionErrorMessage, getHttpValidationErrors} from '../../util/common'
import BootstrapValidation from '../../mixins/bootstrap-validation';
import ldb from '../../thirdparty/localdata'
import axios from "axios";
export default {
    mixins: [BootstrapValidation],
    created(){
        ldb.clear(() => {
            console.info('cleared LDB');
        })
        window.sessionStorage.clear()
        window.localStorage.clear()
        if (this.$route.query) {
            this.user_id = this.$route.query.user_id ? this.$route.query.user_id : null
            if (this.$route.query.reAuthBack) {
                this.redirect = this.$route.query.reAuthBack
            } else if (this.$route.query.redirectTo) {
                this.redirect = this.$route.query.redirectTo
            }
        }
    },
    data() {
        return {
            messages: [],
            errors: [],
            password: '',
            redirect: '',
            username: null,
            user_id: null,
            confirm: false,
            forgot: false,
            loading: false,
        }
    },
    computed: {
        loginMessage(){
            if (this.$route.name === 're-login') {
                return 'You were logged out due to inactivity – please enter password to continue.'
            } else if (window.revoke_reason && window.revoke_reason === 'Dual login') {
                return 'You were logged out because you logged in from another location. Please login to continue.'
            }
        }
    },
    methods: {
        getId(name){
            return name;
        },
        async onSubmit(){
            this.loading = true
            this.messages = [];
            this.errors = [];
            try {
                let response = await this.loginRequest()
                if(response && response.data){
                    this.messages.push({type: 'success', message: response.data.message});
                    this.errors = [];
                    window.location = this.redirect ? this.redirect : '/';
                } else {
                    this.messages.push({type: 'danger', message: 'Something went wrong, please try again.'});
                }
            } catch (error) {
                console.warn('onSubmit error: ', error);
                let message = getExceptionErrorMessage(error);
                this.messages.push({type: 'danger', message});
                let errors = getHttpValidationErrors(error);
                if (errors) {
                    this.errors = errors;
                }
            }
            this.loading = false
        },

        async loginRequest() {
            let url = this.$laravelRoute('login')
            if (this.$route && this.$route.name === 're-login') {
                url = this.$laravelRoute('re-login')
            }
            let data = {
                password: this.password,
                username: this.username,
                user_id: this.user_id,
            }
            if (this.confirm) {
                data.confirmed = 1
            }
            try{
                let response = await axios.post(url, data);
                return response
            } catch (e) {
                console.log('dddd',JSON.parse(JSON.stringify(e)))
                if (e && e.response && e.response.status === 412) {
                    this.confirm = true
                }
                throw e
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Auth/Login.vue